/*
 * Global NY Kicks — functional main-image gallery arrows (desktop).
 *
 * Why this exists:
 * With gallery_layout = "thumbnail_slider", on desktop Dawn shows only
 * the ACTIVE media item (`.product__media-item:not(.is-active){display:none}`).
 * Dawn's generic <slider-component> navigates by horizontal scroll, but
 * with the other images hidden there is nothing to scroll — initPages()
 * filters to items with clientWidth > 0, finds only one, and bails. So the
 * main prev/next arrows render but do nothing when clicked.
 *
 * Fix: reuse the thumbnail buttons (already wired to media-gallery's
 * setActiveMedia) and click the previous/next one. Desktop-only — mobile
 * keeps Dawn's native swipe slider untouched (and the arrows are hidden
 * there anyway via `small-hide`).
 */
(function () {
  const DESKTOP = window.matchMedia('(min-width: 750px)');

  function wire(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer || !thumbs) return;

    const prev = viewer.querySelector('button[name="previous"]');
    const next = viewer.querySelector('button[name="next"]');
    if (!prev || !next) return;

    const navigate = (direction) => (event) => {
      // On mobile, let Dawn's native slider-component handle it.
      if (!DESKTOP.matches) return;
      // Suppress slider-component's inert scroll handler on the same button.
      event.stopImmediatePropagation();

      const buttons = Array.from(thumbs.querySelectorAll('.thumbnail-list__item button'));
      if (buttons.length < 2) return;

      let index = buttons.findIndex((b) => b.getAttribute('aria-current') === 'true');
      if (index === -1) index = 0;
      index = (index + direction + buttons.length) % buttons.length;
      buttons[index].click();
    };

    // Capture phase so we run before slider-component's bubbling listener.
    prev.addEventListener('click', navigate(-1), true);
    next.addEventListener('click', navigate(1), true);
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
